/**
 * Set max height if dropdown would overflow
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  bootstrap.Dropdown.Default.popperConfig = function (defaultBsPopperConfig) {
    return {
      ...defaultBsPopperConfig,
      modifiers: [
        ...defaultBsPopperConfig.modifiers,
        {
          name: 'applyMaxHeight',
          enabled: true,
          phase: 'write',
          requiresIfExists: ['flip', 'preventOverflow'],
          fn({ state }) {
            const reference = state.elements.reference.getBoundingClientRect()

            // An open offcanvas clips its body, so that box - not the viewport - is what the
            // menu has to fit into. Above the navbar breakpoint Bootstrap inlines the panel
            // into the bar and sets the body to overflow-y: visible, so it stops clipping and
            // the viewport is the bound again.
            const clipper = state.elements.reference.closest('.offcanvas-body')
            const clip = clipper && getComputedStyle(clipper).overflowY !== 'visible'
              ? clipper.getBoundingClientRect()
              : { top: 0, bottom: window.innerHeight }

            const spaceBelow = clip.bottom - reference.bottom - 20
            const spaceAbove = reference.top - clip.top - 20

            // Inside a .navbar Bootstrap disables applyStyles, so Popper never positions the
            // menu and state.placement does not describe the side it is rendered on - the
            // stylesheet decides it. Mirror that rule: _custom-navbar.scss flips
            // .offcanvas .dropdown:not(.nav-item) upward below the lg breakpoint. The query
            // is media-breakpoint-down(lg) with $grid-breakpoints lg: 992px; keep it in step
            // with that rule. matchMedia is the same engine evaluating the same query, so it
            // cannot disagree with the CSS it mirrors.
            const cssPositioned = state.elements.popper.dataset.bsPopper === 'static'

            // Use Popper's resolved placement (post flip/preventOverflow) to pick the
            // correct side. Reading popper.getBoundingClientRect() here is unreliable:
            // during the write phase the popper can still report top ~= 0 before final
            // positioning, which wrongly selects spaceAbove and collapses top-of-page
            // dropdowns (e.g. the header account menu) to max-height: 0.
            const opensUpward = cssPositioned
              ? state.elements.reference.closest('.offcanvas .dropdown:not(.nav-item)') !== null
                && window.matchMedia('(max-width: 991.98px)').matches
              : state.placement.startsWith('top')

            const spaceAvailable = opensUpward ? spaceAbove : spaceBelow

            Object.assign(state.elements.popper.style, {
              maxHeight: `${Math.max(spaceAvailable, 0)}px`,
              overflowY: 'auto',
            })
          },
        },
      ],
    }
  }
})()
